import { useState, useRef, useEffect } from 'react';
import { KeyboardArrowDown } from '@mui/icons-material';
import styles from './TextureSelect.module.css';
import { TEXTURE_OPTIONS } from '../../../constants/parameters.constants';
import type { TextureSoil } from '../../../types/parameters.types';

interface TextureSelectProps {
	value: TextureSoil;
	onChange: (value: TextureSoil) => void;
}

export const TextureSelect = ({ value, onChange }: TextureSelectProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const wrapperRef = useRef<HTMLDivElement>(null);

	const currentLabel = TEXTURE_OPTIONS.find((opt) => opt.value === value)?.label ?? value;

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			if (!wrapperRef.current?.contains(e.target as Node)) setIsOpen(false);
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	return (
		<div className={styles.wrapper} ref={wrapperRef}>
			<span className={styles.label}>Textura</span>
			<button
				type="button"
				className={`${styles.control} ${isOpen ? styles.controlOpen : ''}`}
				onClick={() => setIsOpen((prev) => !prev)}
			>
				<span className={styles.value}>{currentLabel}</span>
				<span className={styles.divider} />
				<span className={styles.arrow}>
					<KeyboardArrowDown sx={{ fontSize: 14 }} />
				</span>
			</button>
			{isOpen && (
				<div className={styles.dropdown}>
					{TEXTURE_OPTIONS.map((opt) => (
						<button
							key={opt.value}
							className={`${styles.option} ${opt.value === value ? styles.optionActive : ''}`}
							onClick={() => {
								onChange(opt.value);
								setIsOpen(false);
							}}
						>
							{opt.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
};
